import { trans } from '@spotahome/soyuz/client';

import HouseNotVerifiedIcon from '../icons/HouseNotVerifiedIcon';
import MobileIcon from '../icons/MobileIcon';
import HouseIcon from '../icons/HouseIcon';

import ListingCheckedLabelCircledIcon from '../icons/ListingCheckedLabelCircledIcon';
import InstantBookingLabelCircledIcon from '../icons/InstantBookingLabelCircledIcon';
import BillsLabelCircledIcon from '../icons/BillsLabelCircledIcon';
import CheckPropertyEyeCircledIcon from '../icons/CheckPropertyEyeCircledIcon';

import HouseLabelCircledIcon from '../icons/HouseLabelCircledIcon';
import KeyLabelCircledIcon from '../icons/KeyLabelCircledIcon';

import LongTermLabelCircledIcon from '../icons/LongTermLabelCircledIcon';

import PlusLabelCircledIcon from '../icons/PlusLabelCircledIcon';

import BestChoiceLabelCircledIcon from '../icons/BestChoiceLabelCircledIcon';

import LongTermDescription from '../LongTermDescription';

import PlusLabelDescription from '../PlusLabelDescription';

import PiggyBankLabelCircledIcon from '../icons/PiggyBankLabelCircledIcon';
import LockRoundedIcon from '../icons/LockRoundedIcon';
import DepositProtectionLabelDescription from '../DepositProtectionLabelDescription';

export const IS_CHECKED_FEATURE = 'isCheckedFeature';
export const IS_NOT_CHECKED_FEATURE = 'isNotCheckedFeature';
export const INSTANT_BOOKING_FEATURE = 'instantBookingFeature';
export const INSTANT_BOOKING_FEATURE_ELIGIBLE = 'instantBookingFeatureEligible';
export const GUARANTEE_FEATURE = 'guaranteeFeature';
export const CHECK_24_HOURS_FEATURE = 'check24HoursFeature';
export const NO_DEPOSIT_FEATURE = 'noDepositFeature';
export const DIRECT_LINE_FEATURE = 'directLineFeature';
export const PROPERTY_READY_FEATURE = 'propertyReadyFeature';
export const BILLS_INCLUDED_FEATURE = 'billsIncludedFeature';
export const SOME_BILLS_INCLUDED_FEATURE = 'someBillsIncludedFeature';
export const PRIVATE_LANDLORD_FEATURE = 'privateLandlordFeature';
export const PROFESSIONAL_LANDLORD_FEATURE = 'professionalLandlordFeature';
export const LANDLORD_TYPE_FEATURE = 'landlordTypeFeature';
export const LONG_TERM_FEATURE = 'longTermFeature';
export const IS_BEST_CHOICE_FEATURE = 'isBestChoiceFeature';
export const IS_PLUS_FEATURE = 'isPlusFeature';
export const DEPOSIT_PROTECTION_FEATURE = 'depositProtectionFeature';
export const GRACE_PERIOD_CANCELLATION_FEATURE =
  'gracePeriodCancellationFeature';

export const THEME = 'secondary';

export const FEATURE_LIST = {
  [NO_DEPOSIT_FEATURE]: {
    name: 'noDepositFeature',
    headerKey: 'listing.labels.noDeposit.title',
    renderIcon: () => <PiggyBankLabelCircledIcon />,
    renderBody: () => trans('listing.labels.noDeposit.description')
  },
  [DEPOSIT_PROTECTION_FEATURE]: {
    name: 'depositProtectionFeature',
    headerKey: 'homecard.label.deposit.protected',
    renderIcon: () => <LockRoundedIcon />,
    renderBody: () => <DepositProtectionLabelDescription />
  },
  [INSTANT_BOOKING_FEATURE]: {
    name: 'instantBookingFeature-variant',
    renderIcon: () => <InstantBookingLabelCircledIcon />,
    headerKey: 'property_show.book_now_card.instant_booking'
  },
  [INSTANT_BOOKING_FEATURE_ELIGIBLE]: {
    name: 'instantBookingFeatureEligible',
    renderIcon: () => <InstantBookingLabelCircledIcon />,
    headerKey: 'property_show.book_now_card.instant_booking_eligible',
    renderBody: () =>
      trans('payment-details.add-your-payment.info-instant-booking')
  },
  [IS_NOT_CHECKED_FEATURE]: {
    name: 'isNotVerifiedFeature',
    renderIcon: () => <HouseNotVerifiedIcon />,
    headerKey: 'property_show.book_now_card.not_verified',
    renderBody: () => trans('property_show.book_now_card.not_checked.body'),
    isDangerState: true
  },
  [CHECK_24_HOURS_FEATURE]: {
    name: 'check24Hours',
    renderIcon: () => <CheckPropertyEyeCircledIcon />,
    headerKey: 'property_show.book_now_card.24h',
    renderBody: () => trans('property_show.book_now_card.24h.body')
  },
  [IS_CHECKED_FEATURE]: {
    name: 'isCheckedFeature',
    renderIcon: () => <ListingCheckedLabelCircledIcon />,
    headerKey: 'property_show.book_now_card.checked',
    renderBody: () => trans('property_show.book_now_card.checked.body')
  },
  [DIRECT_LINE_FEATURE]: {
    name: 'directLineFeature',
    renderIcon: () => <MobileIcon />,
    headerKey: 'property_show.book_now_card.direct_line',
    renderBody: () => trans('property_show.book_now_card._direct_line.body')
  },
  [PROPERTY_READY_FEATURE]: {
    name: 'propertyReadyFeature',
    renderIcon: () => <HouseIcon />,
    headerKey: 'property_show.book_now_card.property-ready',
    renderBody: () => trans('property_show.book_now_card.property-ready.body')
  },
  [BILLS_INCLUDED_FEATURE]: {
    name: 'billsIncludedFeature',
    renderIcon: () => <BillsLabelCircledIcon />,
    headerKey: 'listing.labels.bills.all.title',
    renderBody: () => trans('listing.labels.bills.description')
  },
  [SOME_BILLS_INCLUDED_FEATURE]: {
    name: 'someBillsIncludedFeature',
    renderIcon: () => <BillsLabelCircledIcon />,
    headerKey: 'listing.labels.bills.some.title',
    renderBody: () => trans('listing.labels.bills.some.description')
  },
  [PRIVATE_LANDLORD_FEATURE]: {
    name: 'privateLandlordFeature',
    renderIcon: () => <KeyLabelCircledIcon />,
    headerKey: 'listing.landlord_info.type.professional'
  },
  [PROFESSIONAL_LANDLORD_FEATURE]: {
    name: 'professionalLandlordFeature',
    renderIcon: () => <HouseLabelCircledIcon />,
    headerKey: 'listing.landlord_info.type.private'
  },
  [LONG_TERM_FEATURE]: {
    name: 'longTermFeature',
    renderIcon: () => <LongTermLabelCircledIcon />,
    headerKey: 'homecard.label.long-term',
    renderBody: () => <LongTermDescription />
  },
  [IS_BEST_CHOICE_FEATURE]: {
    name: 'isBestChoiceFeature',
    renderIcon: () => <BestChoiceLabelCircledIcon />,
    headerKey: 'listing.labels.bestChoice.title',
    renderBody: () => trans('listing.labels.bestChoice.description')
  },
  [IS_PLUS_FEATURE]: {
    name: 'isPlusFeature',
    renderIcon: () => <PlusLabelCircledIcon />,
    headerKey: 'Spotahome PLUS',
    renderBody: () => <PlusLabelDescription />
  }
};

export default {
  THEME,
  FEATURE_LIST,
  NO_DEPOSIT_FEATURE,
  INSTANT_BOOKING_FEATURE,
  GUARANTEE_FEATURE,
  IS_NOT_CHECKED_FEATURE,
  CHECK_24_HOURS_FEATURE,
  DIRECT_LINE_FEATURE,
  PROPERTY_READY_FEATURE,
  IS_CHECKED_FEATURE
};
